import { useI18n } from "i18n";
import { Loader } from "@remo-co/ui-core/src/components/Loader";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useSelector } from "react-redux";
import { selectEnableAgencyWhiteLabelling } from "modules/settings/redux/selectors";
import { useStyles } from "./styles";

const LoadingChat = () => {
  const enableAgencyWhiteLabelling = useSelector(
    selectEnableAgencyWhiteLabelling,
  );
  const styles = useStyles();
  const { t } = useI18n("common");

  const supportTranslationKey = enableAgencyWhiteLabelling
    ? "we.re.connecting.you.to.support.white.label"
    : "we.re.connecting.you.to.support";

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Loader thickness={2} />
      </div>
      <Typography variant="body1" color="textPrimary">
        {t("hang.on")}
      </Typography>
      <Typography variant="body1" color="textPrimary">
        {t(supportTranslationKey)}
      </Typography>
    </div>
  );
};

export default LoadingChat;
